import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Processors } from '../../../constants/AppConstants';
import { updatePaymentState } from '../../../redux/PaymentState/PaymentState.actions';
var RecurlyService = /*#__PURE__*/function () {
  function RecurlyService(params) {
    _classCallCheck(this, RecurlyService);
    _defineProperty(this, "type", Processors.RECURLY);
    _defineProperty(this, "dispatch", void 0);
    _defineProperty(this, "clientInstance", null);
    this.dispatch = params.dispatch;
    this.initialize(params);
  }
  return _createClass(RecurlyService, [{
    key: "initialize",
    value: function initialize(_ref) {
      var callback = _ref.callback;
      callback(this);
      if (this.clientInstance) return;
      this.dispatch(updatePaymentState({
        isLoading: false
      }));
    }
  }]);
}();
export { RecurlyService as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/business/processors/recurly/RecurlyService.js
// module id = 4606
// module chunks = 11